export default {
  bindings: {
    manager: '<',
    course: '<',
  },
  controller: function ctrl(
    CurrentUserManager,
    TimelinesManager,
  ) {
'ngInject';
    const vm = this;
    vm.CurrentUserManager = CurrentUserManager;
    vm.TimelinesManager = TimelinesManager;

    vm.showAddSectionComponent = function (cond = null) {
      let show = vm.TimelinesManager.isEditMode() && vm.TimelinesManager.currentTimeline && (vm.TimelinesManager.currentTimeline.lectureSections.length || vm.TimelinesManager.currentTimeline.lectureSubsections.length);
      if (cond != null) {
        show = show && cond;
      }
      return show;
    };

    return vm;
  },
  controllerAs: 'vm',
  templateUrl: 'timelines/templates/nv-new-timeline-full.html',
};
